module.exports = __webpack_public_path__ + "img/img_82837_0_36.13d43bb5.png";